import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-bem-vindo',
    templateUrl: './bem-vindo.component.html'
})

export class BemVindoComponent
{
}


